export default __webpack_public_path__ + "static/media/us.02012f9a.svg";